import { Filter } from '@libs/models/common';
import dayjs from 'dayjs';

export function filterToQueryParams(filters: Filter[], { removeEmpty }: Options = {}) {
  return filters?.reduce<Record<string, string[] | string | number>>((acc, filter) => {
    if (filter.key === 'startDate' && typeof filter.value === 'object' && !Array.isArray(filter.value)) {
      return {
        ...acc,
        ...(filter.value.from && { [`startDate`]: dayjs(filter.value.from).toServerFilterDate() }),
        ...(filter.value.to && { [`endDate`]: dayjs(filter.value.to).toServerFilterDate() }),
        // [`timeZone`]: filter.value.timezone,
      };
    }
    if (typeof filter.value === 'object' && !Array.isArray(filter.value)) {
      return {
        ...acc,
        [`${filter.key}_from`]: [filter.value.from.toISOString()],
        [`${filter.key}_to`]: [filter.value.to.toISOString()],
      };
    }
    if (Array.isArray(filter.value) && filter.value.length === 0 && removeEmpty) {
      return { ...acc };
    }
    if (typeof filter.value === 'string' && filter.value.length === 0 && removeEmpty) {
      return { ...acc };
    }
    return { ...acc, [`${filter.key}_in`]: filter.value };
  }, {});
}

type Options = {
  removeEmpty?: boolean;
};
